;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import Text from 'components/ui/Text';

const convertLineBreaks = (str = '') =>
    str
        .split('\n')
        .flatMap((text, i) => [i > 0 ? <br key={i} /> : null, text])
        .filter(item => item !== null);

// Helper function to safely get text content from a rich text node
const getTextFromNode = node => {
    if (node.nodeType === 'text' && 'value' in node) {
        return node.value;
    }
    return undefined;
};

const RichHeadline = ({ richText = {} }) => {
    const themeMap = {
        [BLOCKS.PARAGRAPH]: {
            className: 'paragraph',
            tag: 'h3',
            baseTheme: 'headingMedium',
            themes: {
                large: 'headingLarge',
            },
        },
        [BLOCKS.HEADING_3]: {
            className: 'heading3',
            tag: 'h3',
            baseTheme: 'displayXSmall',
            themes: {
                large: 'displayMedium',
            },
        },
        // Fallback for any other node types
        default: {
            className: 'paragraph',
            tag: 'h3',
            baseTheme: 'headingMedium',
            themes: {
                large: 'headingLarge',
            },
        },
    };

    if (!richText?.json?.content || !Array.isArray(richText.json.content)) {
        return null;
    }

    return richText.json.content.map((item, i) => {
        // Get the first text node's content if it exists
        const textNode = item.content?.[0];
        const value = textNode ? getTextFromNode(textNode) : undefined;

        if (value) {
            // Allow line breaks for typography control while retaining semantics
            const content = convertLineBreaks(value);

            // Get theme settings, defaulting to paragraph if nodeType isn't recognized
            const themeSettings = themeMap[item.nodeType] || themeMap.default;

            return (
                <Text
                    key={i}
                    as={themeSettings.tag}
                    baseTheme={themeSettings.baseTheme}
                    themes={{
                        medium: themeSettings.themes?.medium || '',
                        large: themeSettings.themes?.large || '',
                    }}
                >
                    {content}
                </Text>
            );
        }
        // Remove tags if empty, i.e <p></p> <h3></h3>
        return null;
    });
};

RichHeadline.propTypes = {
    richText: PropTypes.object,
};

export default RichHeadline;
